import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ReportsService } from 'src/app/features/reports/reports.service'; 
import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-refund-smart',
  template: `<app-refund [refund]="refund" [summary]="summary" [startDate]="startDate" [endDate]="endDate"></app-refund>`,
  styles: [
  ]
})
export class RefundSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  refund: any =[];
  summary: any = 0;
  startDate;
  endDate;


  constructor(private reportsService: ReportsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
    
    let curdate = new Date().getFullYear().toString() +'-'+(new Date().getMonth() + 1).toString()+'-01';
    this.endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.startDate = formatDate(curdate, 'yyyy-MM-dd', 'en');
    let params: any = new HttpParams().set('startDate', this.startDate).set('endDate', this.endDate )


    this.reportsService.getrefundSummary(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
      }
    })    
	
    this.reportsService.getrefund(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.refund=resData;
      }
    })
	}

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
}
